
import Vue from 'vue';
import { IDescriptions, IGroup } from '../store/insights';
import gql from 'graphql-tag';
import Moment from 'moment';
import { PublisherStatistic } from '~/shared/types/api';
import { normalizeDateRange } from '~shared/utils';

export default Vue.extend({
  data() {
    return {
      startDate: '',
      endDate: '',
      statistics: [],
      skipQuery: true,
      initialFetched: false,
    };
  },
  props: {
    isNoData: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    view(): string {
      return this.$store.state['insights'].filters.view.toUpperCase();
    },
    groupBy(): string {
      return this.$store.state.insights.filters.groupBy;
    },
    fetchedDataDescriptions(): IDescriptions {
      return this.$store.state.insights.fetchedDataDescriptions;
    },
    currency(): string {
      return (this.$store.state.insights.filters.selectedGroup || {}).currency;
    },
    widgetIds(): string[] {
      return this.$store.state.insights.filters.selectedWidgets.map(w => w.id);
    },
    dateRange(): Date[] {
      return this.$store.state.insights.filters.dateRange;
    },
    selectedGroup(): IGroup | null {
      return this.$store.state.insights.filters.selectedGroup;
    },
    includeArchivedWidgets(): boolean {
      return this.$store.state.insights.filters.includeArchivedWidgets;
    },
    widgetsInitialized(): boolean {
      return this.$store.state.insights.widgetsInitialized;
    },
  },
  watch: {
    dateRange: {
      handler(val) {
        if (val.length === 2) {
          const { startDate, endDate } = normalizeDateRange({ startDate: val[0], endDate: val[1] });

          this.startDate = startDate.toISOString();
          this.endDate = endDate.toISOString();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  apollo: {
    statistics: {
      query: gql`
        query(
          $groupId: ID!
          $start: DateTime!
          $end: DateTime!
          $resolution: PublisherStatisticsResolution
          $groupBy: PublisherStatisticsGroupBy
          $widgetIds: [ID!]
          $includeArchivedWidgets: Boolean
        ) {
          PublisherStatistics(
            groupId: $groupId
            startDate: $start
            endDate: $end
            resolution: $resolution
            groupBy: $groupBy
            widgetIds: $widgetIds
            includeArchivedWidgets: $includeArchivedWidgets
          ) {
            lastUpdated
            statistics {
              date
              widgetName
              widgetId
              revenueLocalCurrency
              localCurrency
              widgetImpressions
              widgetCtr
              totalClicks
              articleClicks
              adClicks
              houseAdClicks
              totalImpressions
              articleImpressions
              adImpressions
              houseAdImpressions
              articleCtr
              adCtr
              houseAdCtr
              inviewPercentage
              inviewRPM
            }
          }
        }
      `,
      variables(): any {
        return {
          groupId: this.selectedGroup ? this.selectedGroup.id : '',
          start: this.startDate,
          end: this.endDate,
          resolution: this.view,
          groupBy: this.groupBy.toUpperCase(),
          widgetIds: this.widgetIds,
          includeArchivedWidgets: this.includeArchivedWidgets,
        };
      },
      skip(): boolean {
        return !this.widgetsInitialized;
      },
      debounce: 1000,
      fetchPolicy: 'no-cache',
      notifyOnNetworkStatusChange: true,
      deep: true,
      update(data): [] {
        
        this.$emit('update:isNoData', data.PublisherStatistics.statistics.length === 0 || !data.PublisherStatistics.statistics.length);

        if (data.PublisherStatistics) {
          this.$store.dispatch('insights/setFetchedDataDescriptions');
          if (this.view === 'DAY') {
            const format = 'MMMM D, YYYY';
            data.PublisherStatistics.statistics.forEach(
              (s: PublisherStatistic) => {
                // Same here, fix timezone side effects in the statistics list
                const m = Moment(s.date);
                m.subtract(m.utcOffset(), 'minutes');
                s.date = m.format(format);
              }
            );
          }
          this.$store.commit(
            'insights/SET_SHOWING_COUNT',
            data.PublisherStatistics.statistics.length
          );
          this.$store.commit(
            'insights/SET_LAST_UPDATED',
            data.PublisherStatistics.lastUpdated
          );
          this.initialFetched = true;
          return data.PublisherStatistics.statistics;
        }
        return [];
      },
      error() {
        this.initialFetched = true;
        this.$snotify.error('Something went wrong, try again a bit later.');
      },
    },
  },
});
